module.exports = __webpack_public_path__ + "static/media/favicon.438f8ba1.ico";